import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { RequestState } from '../../models/request-state';
import { FieldConditionResponse } from './models/field-condition.response';
import { ApiCacheService } from '../api-cache.service';

@Injectable({
  providedIn: 'root',
})
export class FieldConditionService {
  private readonly URL = `${environment.apiUrl}fieldcondition`;

  constructor(private cacheService: ApiCacheService) {}

  getFieldCondition(
    station: string
  ): Observable<RequestState<FieldConditionResponse>> {
    const cacheId = this.getCacheId(station);
    const url = `${this.URL}/${station}`;
    console.log(url);
    return this.cacheService.request(cacheId, url);
  }

  refreshFieldCondition(
    station: string
  ): Observable<RequestState<FieldConditionResponse>> {
    const cacheId = this.getCacheId(station);
    const url = `${this.URL}/${station}`;
    console.log(url);
    return this.cacheService.forceRefreshGet(cacheId, url);
  }

  private getCacheId(station: string): string {
    return `field-condition-${station}`;
  }
}
